import React from 'react';
import BaseNode from "./base-node.jsx";
import CheckHasData from "../check-has-data.jsx";
import {FaCircleInfo} from "react-icons/fa6";
import {Types} from "../enums.js";
import {FaImage} from "react-icons/fa";
import {LoadImage} from "../get-image.jsx";
import {useNodeId} from "@xyflow/react";

const Image = ({ data, selected }) => {
    const nodeId = useNodeId();

    const title = () => {
        return (
            <>
                <p className={"!mb-[2px]"}><b>Imagem</b></p>
            </>
        )
    }

    const icon = (<FaImage size={16} color={"#031b34"}/>);

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex items-center mb-1"}>
                <LoadImage nodeId={nodeId}/>
            </div>
            <div className={"flex"}>
                <div>
                    <FaCircleInfo />
                </div>
                <p className="mb-0 ml-1 text-[6px] overflow-hidden [display:-webkit-box] [-webkit-line-clamp:4] [-webkit-box-orient:vertical]">
                    <CheckHasData value={data.additionalValue} />
                </p>
            </div>
        </div>
    );

    return (
        <BaseNode
            icon={icon}
            title={title()}
            image={null}
            infoBlock={infoBlock}
            onSearchAll={() => {}}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#e68eea]"}
            bgBody={"bg-[#eadcea]"}
            type={Types.IMAGE}
        />
    );
};

export default Image;